module.exports = __webpack_public_path__ + "static/media/cozy9207.08d60de8.jpg";